import axios from 'axios'

const state = {
  pageMetaList: [],
  singlePageMeta: null,
}

const getters = {
  getPageMetaList (state) {
    return state.pageMetaList
  },
  getSinglePageMeta (state) {
    return state.singlePageMeta
  },
}

const mutations = {
  setPageMetaList (state, payload) {
    state.pageMetaList = payload
  },
  setSinglePageMeta (state, payload) {
    state.singlePageMeta = payload
  },
  clearSinglePageMeta (state) {
    state.singlePageMeta = null
  },
}

const actions = {
  fetchPageMetaList ({ commit, rootGetters }, meta) {
    return axios
      .get(rootGetters['api/seoPageMetaList'], {
        params: meta,
      })
      .then((res) => {
        commit('setPageMetaList', res.data.items)
        return res.data.items
      })
  },
  fetchSinglePageMeta ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/seoPageMetaSingle'](id))
      .then((res) => {
        commit('setSinglePageMeta', res.data.data)
        return res.data.data
      })
  },
  createPageMeta ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/seoPageMetaCreate'], data)
      .then((res) => {
        return res
      })
  },
  editPageMeta ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/seoPageMetaEdit'](id), data)
  },
  deletePageMeta ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/seoPageMetaDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getPageMetaList.filter((val) => val.id !== id)
          commit('setPageMetaList', items)
        }

        return res
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
